import styled from 'styled-components';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useProductContext } from './context/productContext';
import { Container } from './styles/Container';
import MyImages from './components/MyImages';
import FormatPrice from './Helper/FormatPrice';
import { TbTruckDelivery, TbReplace } from 'react-icons/tb';
import { MdSecurity } from 'react-icons/md';
import Stars from './components/Stars';
import AddToCart from './components/AddToCart';

const API = 'https://e-com-app-be.onrender.com/api/products';

const SingleProduct = () => {
  const { id } = useParams();
  const { getSingleProduct, isSingleLoading, singleProduct } =
    useProductContext();

  const {
    id: alias,
    name,
    company,
    description,
    price,
    reviews,
    stars,
    stock,
    image,
  } = singleProduct;

  useEffect(() => {
    getSingleProduct(`${API}/${id}`);
  }, [id, getSingleProduct]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isSingleLoading) {
    return <p>Loading.........</p>;
  }

  return (
    <Wrapper>
      <Container className='container'>
        <div className='grid grid-two-column'>
          <div className='product_images'>
            <MyImages image={image} />
          </div>
          <div className='product-data'>
            <h2>{name}</h2>
            <Stars stars={stars} reviews={reviews} />
            <p className='product-data-price'>
              MRP:
              <del>
                <FormatPrice price={price} />
              </del>
            </p>
            <p className='product-data-price product-data-real-price'>
              Deal of the Day: <FormatPrice price={price - price * 0.2} />
            </p>
            <p>{description}</p>
            <div className='product-data-warranty'>
              <div className='product-warranty-data'>
                <TbTruckDelivery className='warranty-icon' />
                <p>Free Delivery</p>
              </div>
              <div className='product-warranty-data'>
                <TbReplace className='warranty-icon' />
                <p>30 days replacement</p>
              </div>
              <div className='product-warranty-data'>
                <MdSecurity className='warranty-icon' />
                <p>1 year warranty</p>
              </div>
            </div>
            <div className='product-data-info'>
              <p>
                Available:
                <span>{stock > 0 ? 'in stock' : 'out of stock'}</span>
              </p>
              <p>
                Brand:
                <span>{company}</span>
              </p>
              <p>
                Product Id:
                <span>{alias}</span>
              </p>
            </div>
            <hr />
            {stock > 0 && <AddToCart product={singleProduct} />}
          </div>
        </div>
      </Container>
    </Wrapper>
  );
};
const Wrapper = styled.section`
  .container {
    padding: 9rem 0;
  }
  .grid {
    margin-top: 3rem;
  }
  .product-data {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 2rem;

    .product-data-warranty {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ccc;
      margin-bottom: 1rem;

      .product-warranty-data {
        text-align: center;

        .warranty-icon {
          background-color: rgba(220, 220, 220, 0.5);
          border-radius: 50%;
          width: 4rem;
          height: 4rem;
          padding: 0.6rem;
        }
        p {
          font-size: 1.4rem;
          padding-top: 0.4rem;
        }
      }
    }

    .product-data-price {
      font-weight: bold;
    }
    .product-data-real-price {
      color: rgb(235, 143, 52);
    }
    .product-data-info {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-size: 1.8rem;

      span {
        font-weight: bold;
      }
    }

    hr {
      max-width: 100%;
      width: 90%;
      /* height: 0.2rem; */
      border: 0.1rem solid #000;
      color: red;
    }
  }

  .product-images {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    padding: 0 2.4rem;
  }
`;

export default SingleProduct;
